<!--CollapseIntro:层叠方式介绍信息 2021/12/22 15:07:08 YuAng-->

<template>
  <div class="ho-collapse-intro">
    <p v-if="title" class="ho-part-title">{{title}}</p>
    <ul>
      <li v-for="(item,index) in list" :key="'li' + index">
        <p class="good-title" @click="item.fold = !item.fold">
          <span>{{item.title}}</span>
          <van-icon :name="item.fold ? 'arrow-down' : 'arrow-up'" />
        </p>
        <p v-show="!item.fold" class="good-desc" v-html="item.desc">描述信息</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'CollapseIntro',
  props: {
    title: {
        type: String,
        return: '主题标题'
    },
    list: {
      type: Array,
      default: function () {
        return [
          {
            title: '优质资源 随取随用',
            desc: '教学资源覆盖K12全学科、全学段，如：课件、教案学案、素材、视频、试题、试卷等。',
            fold: false
          },
          {
            title: '教学全流程覆盖',
            desc: '在线轻松备课，智能高效授课，预习训练一键收发，教学设计有方，学生自主学习，成绩精准提高。',
            fold: true
          },
          {
            title: '英语专业教研 学科特色保障',
            desc: '英语学科特色内容题库支持按语言能力场景高效选择，听说读写特色练习，口语精准测评。',
            fold: true
          },
          {
            title: '开放式平台 区校本资源共建共享',
            desc: '开放式平台，汇聚特色教学应用，区域资源共建共享，资源分发一触即达。',
            fold: true
          },
          {
            title: '学情数据可视 智慧科学管理',
            desc: '学情分析帮助教师精准教学，教学大数据助力区、校领导智慧管理，科学决策。',
            fold: true
          }
        ]
      }
    }
  }
}
</script>

<style scoped>

.ho-collapse-intro {
  padding: 8px 16px 16px 16px;
}

.ho-collapse-intro li {
  border: 1px solid #c9e4ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  margin-bottom: 16px;
  min-height: 52px;
  overflow: hidden;
}

.ho-collapse-intro .good-title {
  height: 52px;
  line-height: 52px;
  font-weight: bold;
  background: #f5faff;
  padding: 0 16px;
}

.good-title >>> .van-icon {
  float: right;
  margin-top: 13px;
  background: #9cc2ff;
  color: white;
  padding: 4px;
  border-radius: 50%;
}

.ho-collapse-intro .good-desc {
  font-size: 12px;
  padding: 8px 16px;
  background: url(../../../../assets/images/mobile/home_part4_book.png)
    no-repeat;
  background-position: 106% 106%;
  background-size: 25%;
  line-height: 1.5;
}
</style>